module.exports = __webpack_public_path__ + "media/images/home-banners/ama-dablam-2064522_1920-ddf96ed47fb6317223cd34f390c86491.jpg";